import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { LayerGroupIcon } from '@/icons';
import { groupQueries } from '@/services/groupsManagement/groupsManagement.queries';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/group-management/$sub-group')({
  component: RouteComponent,
  //To display the selected group name in the breadcrumb and page title.
  loader: async ({ params, context: ctx }) => {
    const groupId = params['sub-group'];
    const queryOptions = groupQueries.detail(groupId);
    const actualQueryFn = queryOptions.queryFn(ctx.client);
    const groupDetail = await ctx.queryClient.ensureQueryData({
      ...queryOptions,
      queryFn: actualQueryFn,
    });

    const groupName = groupDetail?.data?.groupName || 'Selected Group';

    return {
      crumb: <CrumbTitle title={`${groupName}`} icon={LayerGroupIcon} />,
      title: (
        <Translation
          id="configurationManagement.groupsManagement.subGroup.pageTitle"
          values={{ selectedGroup: groupName }}
        />
      ),
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
